import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home'
import Index from '../pages/index'
import classSystem from '../pages/classSystem'
import brandIntr from '../pages/brandIntr'
import teacherTeams from '../pages/teacherTeams'
import aboutUs from '../pages/aboutUs'
import studentStatus from '../pages/studentStatus'
import grading from '../pages/grading'
import gradingTest from '../pages/grading_test/testIndex'
import gradingIndex from '../pages/grading_test/testPasscart'
import gradingDoTest from '../pages/grading_test/dotest'
import gradingResults from '../pages/grading_test/testResults'
import gradingGoChess from '../pages/grading_test/gochess'
import chessCet11 from '../pages/grading_test/chessCet11'
import goNotice from '../pages/go_test/goNotice'
import gotest from '../pages/go_test/gotest'
import goChess from '../pages/go_test/chessTest'
import gotestResults from '../pages/go_test/gotestResults'
import chessNotice from '../pages/chess_test/chessNotice'
import chessPasscart from '../pages/chess_test/chessPasscart'
import chessSelect from '../pages/chess_test/chessSelect'
import chessBase from '../pages/chess_test/chessBase'
import chessResults from '../pages/chess_test/chessResults'
// eslint-disable-next-line no-unused-vars
import yhxy from '../pages/yhxy'
import yssm from '../pages/yssm'
import bqsm from '../pages/bqsm'
// import demo from '../pages/grading_test/demo'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          component: Index,
          meta: {
            title: '弈小象'
          }
        },
        {
          path: '/classSystem',
          name: 'classSystem',
          component: classSystem
        },
        {
          path: '/brandIntr',
          name: 'brandIntr',
          component: brandIntr
        },
        {
          path: '/teacherTeams',
          name: 'teacherTeams',
          component: teacherTeams
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs
        },
        {
          path: '/studentStatus',
          name: 'studentStatus',
          component: studentStatus
        },
        {
          path: '/yhxy',
          name: 'yhxy',
          // eslint-disable-next-line no-undef
          component: yhxy
        },
        {
          path: '/yssm',
          name: 'yssm',
          // eslint-disable-next-line no-undef
          component: yssm
        },
        {
          path: '/bqsm',
          name: 'bqsm',
          // eslint-disable-next-line no-undef
          component: bqsm
        }
      ]
    },
    {
      path: '/goNotice',
      name: 'goNotice',
      component: goNotice,
      meta: {
        title: '围棋等级考试'
      }
    },
    {
      path: '/gotest',
      name: 'gotest',
      component: gotest
    },
    {
      path: '/goChess',
      name: 'goChess',
      component: goChess,
      meta: {
        title: '围棋等级考试'
      }
    },
    {
      path: '/gotestResults',
      name: 'gotestResults',
      component: gotestResults
    },
    {
      path: '/grading',
      name: 'grading',
      component: grading,
      redirect: '/gradingTest',
      children: [
        {
          path: '/gradingTest',
          name: 'gradingTest',
          component: gradingTest,
          meta: {
            title: '象棋等级考试指定网站'
          }
        },
        {
          path: '/gradingDoTest',
          name: 'gradingDoTest',
          component: gradingDoTest
        },
        {
          path: '/gradingResults',
          name: 'gradingResults',
          component: gradingResults,
          meta: {
            title: '象棋等级考试指定网站'
          }
        },
        {
          path: '/gradingGoChess',
          name: 'gradingGoChess',
          component: gradingGoChess
        },
        {
          path: '/chessCet11',
          name: 'chessCet11',
          component: chessCet11
        }
      ]
    },
    {
      path: '/gradingIndex',
      name: 'gradingIndex',
      component: gradingIndex
    },
    {
      path: '/chessNotice',
      name: 'chessNotice',
      component: chessNotice,
      meta: {
        title: '国际象棋等级考试指定网站'
      }
    },
    {
      path: '/chessBase',
      name: 'chessBase',
      component: chessBase,
      meta: {
        title: '国际象棋等级考试指定网站'
      }
    },
    {
      path: '/chessResults',
      name: 'chessResults',
      component: chessResults,
      meta: {
        title: '国际象棋等级考试指定网站'
      }
    },
    {
      path: '/chessSelect',
      name: 'chessSelect',
      component: chessSelect
    },
    {
      path: '/chessPasscart',
      name: 'chessPasscart',
      component: chessPasscart
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js